
import { PhoneCase } from '@qcases/common';
import axios from 'axios';
import { BASE_API_URL } from '../../domain/constants/api';

function getProducts() {
  return axios
    .get<PhoneCase[]>(`${BASE_API_URL}/phone-cases`)
    .then(res => res.data);
}

export { getProducts };
